import React from "react";
import "./../../css/HomeTrusted.css";
import Heading from "./../../ui/heading";
import { Check } from "lucide-react";
import {
  FaAward,
  FaBookOpen,
  FaHeadset,
  FaTruck,
  FaUser,
} from "react-icons/fa";
import { ProfImage } from "../../assets/images";

const HomeTrusted = () => {
  return (
    <section className='home-trusted-section'>
      <div className='home-trusted-container grid lg:grid-cols-2'>
        <div className='trusted-image-wrapper'>
          <img src={ProfImage} className='trusted-image' alt='' />
          <div className='trusted-stats'>
            <div className='trusted-stat'>
              <span className='trusted-stat-icon'>
                <FaUser className='trusted-stat-icon-inner' />
              </span>
              <div className='trusted-stat-text'>
                <span className='trusted-stat-number'>20k+</span>
                <p className='trusted-stat-label'>Happy Users</p>
              </div>
            </div>
            <div className='trusted-stat border-left'>
              <span className='trusted-stat-icon'>
                <FaAward className='trusted-stat-icon-inner' />
              </span>
              <div className='trusted-stat-text'>
                <span className='trusted-stat-number'>20k+</span>
                <p className='trusted-stat-label'>Happy Users</p>
              </div>
            </div>
          </div>
        </div>
        <div className='trusted-content'>
          <h2 className='trusted-title'>
            Trusted by industries nationwide for expert dust collection services
          </h2>
          <ul className='trusted-list'>
            {LIST_ITEMS.map((item) => (
              <li key={item} className='trusted-list-item'>
                <span className='trusted-list-icon'>
                  <Check className='trusted-check-icon' />
                </span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className='trusted-divider'></div>
      <div className='trusted-services'>
        {SERVICES.map((item) => (
          <div key={item.title} className='trusted-service'>
            <span className='trusted-service-icon'>{item.icon}</span>
            <div className='trusted-service-text'>
              <span className='trusted-service-title'>{item.title}</span>
              <p>{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

const LIST_ITEMS = [
  "Over 40 years of specialized experience in air pollution control.",
  "Custom-engineered solutions for regulatory compliance.",
  "Preventive maintenance plans to reduce costly downtime.",
  "Explore our full suite of industrial services.",
  "Speak directly with seasoned filtration specialists.",
];

const SERVICES = [
  {
    icon: <FaBookOpen color='#0076fe' />,
    title: "Baghouse Catalog",
    description: "Click here to view our complete catalog",
  },
  {
    icon: <FaTruck color='#0076fe' />,
    title: "Get It Fast",
    description: "Offering one-day delivery of filter bags & parts!",
  },
  {
    icon: <FaHeadset color='#0076fe' />,
    title: "Non-Stop Support",
    description: "Our friendly staff are available to support you 24/7",
  },
];

export default HomeTrusted;
